/*
 * @Author: cc
 * @Date: 2020-01-08 13:17:09
 * @LastEditTime: 2021-04-25 15:02:38
 * @LastEditors: lzy
 * @FilePath: \xjmediacloud\app\editingCenter\directive\editPagePart\editPagePart.js
 * @Description:拆分采编编辑页
 */
angular
    .module('editPageModule', [
        'editPageFacepicModule',
        'editPageEditorModule',
        'editPageProcessLineModule',
        'editPageLinkModule',
        'editPageMusendModule',
        'editPageTipsModule',
        'editPageTypeModule',
        'editPageVideoFooterModule',
        'editPageVideoUploadModule',
        'editPageButtonModule',
        'editPageOriginModule', // 原创与特殊
        'editPageExtrasModule', // 附加信息组件
        'AppeditPageModule', // App渠道专用
        'editPageAppendixUploadModule',
        'recommendedChannelsModule'
    ])
    .controller('editPageCtrl', ['$scope', function($scope) {}]);
